import { FolderResourceTemplate } from '../folder-structure.types';

export namespace FolderTemplatesActions {
  export class LoadAll {
    static readonly type = '[FolderTemplates] Load All';
    constructor(public q?: string) {}
  }

  export class GetById {
    static readonly type = '[FolderTemplates] Get By Id';
    constructor(public id: string) {}
  }

  export class Create {
    static readonly type = '[FolderTemplates] Create';
    constructor(
      public params: {
        name: string;
        related_to_type: string;
        project_template_id: number | null;
        definition: FolderResourceTemplate.ItemDefinition[];
      },
    ) {}
  }

  export class Update {
    static readonly type = '[FolderTemplates] Update';
    constructor(
      public id: string,
      public params: {
        name: string;
        project_template_id: number | null;
        definition: FolderResourceTemplate.ItemDefinition[];
      },
    ) {}
  }

  export class Delete {
    static readonly type = '[FolderTemplates] Delete';
    constructor(public id: string) {}
  }
}
